import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useSenderEmailValidList } from 'shared/components/sender-email-select/hooks/use-sender-email-valid-list';
import { SenderEmailSelectProps } from 'shared/components/sender-email-select/index';
export const useSetDefaultSenderEmail = (value, onChange) => {
  const $ = _c(9);
  const {
    data: senderEmailValidList
  } = useSenderEmailValidList();
  let t0;
  if ($[0] !== onChange || $[1] !== senderEmailValidList || $[2] !== value) {
    t0 = () => {
      if (!value) {
        return;
      }
      if (!senderEmailValidList) {
        return;
      }
      if (!senderEmailValidList.map(_temp).includes(value.toString())) {
        onChange("");
      }
    };
    $[0] = onChange;
    $[1] = senderEmailValidList;
    $[2] = value;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== senderEmailValidList || $[5] !== value) {
    t1 = [senderEmailValidList, value];
    $[4] = senderEmailValidList;
    $[5] = value;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  useEffect(t0, t1);
  let t2;
  if ($[7] !== senderEmailValidList) {
    t2 = {
      senderEmailValidList
    };
    $[7] = senderEmailValidList;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
function _temp(t0) {
  const {
    email
  } = t0;
  return email;
}